import { Component } from '@angular/core';
import { Store } from '@ngxs/store';
import { ChatbotActions } from '../../../state/chatbot.actions';

@Component({
  selector: 'hf-warning-template',
  templateUrl: './warning-template.component.html',
  styleUrls: ['./warning-template.component.scss']
})
export class WarningTemplateComponent {
  constructor(private readonly store: Store) {}

  public onReturnToPreviousChatbotState() {
    this.store.dispatch(new ChatbotActions.WarningStateUI(false));
  }

  public onProceedToNewChatState() {
    this.store.dispatch(new ChatbotActions.NewChatUI(true));
    this.store.dispatch(new ChatbotActions.StartNewWSConversation());
    this.store.dispatch(new ChatbotActions.WarningStateUI(false));
  }
}
